module.exports = __webpack_public_path__ + "images/exploding-head-gif-2.gif";